export type XmlPath = readonly string[];

export const extractXmlTextByPath = (
  xml: string,
  path: readonly string[],
): string | null => {
  if (!xml || !path?.length) return null;
  const norm = xml.replace(/\r\n?/g, '\n').trim();

  const segmentBetween = (src: string, tag: string): string | null => {
    const open = new RegExp(`<${tag}(\\s[^>]*)?>`, 'i');
    const close = new RegExp(`</${tag}>`, 'i');
    const openMatch = open.exec(src);
    if (!openMatch) return null;
    const tail = src.slice(openMatch.index + openMatch[0].length);
    const closeMatch = close.exec(tail);
    if (!closeMatch) return null;
    return tail.slice(0, closeMatch.index);
  };

  const inner = path.reduce<string | null>(
    (acc, tag) => (acc === null ? null : segmentBetween(acc, tag)),
    norm,
  );
  if (inner === null) return null;

  return inner.replace(/<!\[CDATA\[([\s\S]*?)\]\]>/gi, '$1').trim();
};

export const extractXmlNumberByPath = (
  xml: string,
  path: XmlPath,
): number | null => {
  const txt = extractXmlTextByPath(xml, path);
  if (txt == null || txt === '') return null;

  const s = txt.trim();
  const hasComma = s.includes(',');
  const hasDot = s.includes('.');

  let normalized = s;
  if (hasComma && hasDot) {
    const lastComma = s.lastIndexOf(',');
    const lastDot = s.lastIndexOf('.');
    normalized =
      lastComma > lastDot
        ? s.replace(/\./g, '').replace(',', '.')
        : s.replace(/,/g, '');
  } else if (hasComma) {
    normalized = s.replace(/\./g, '').replace(',', '.');
  }

  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
};
